





































import Vue from 'vue';
import { mapActions } from 'vuex';
import { VBTooltip } from 'bootstrap-vue';

const ESCAPE_KEY = 27;
const ENTER_KEY = 13;

export default Vue.extend({
  name: 'EditableLabel',
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    editButtonAlignLeft: {
      type: Boolean,
      default: false,
    },
    emptyError: {
      type: String,
      default: 'Invalid empty string',
    },
  },
  data() {
    return {
      myEditing: false,
      isEditing: false,
    };
  },
  watch: {
    editing: {
      handler(value) {
        if (!value || this.myEditing) return;
        this.toggleEdit();
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
    onChange(e) {
      const newValue = e.target.value;
      if (this.emptyError && !newValue.trim()) {
        this.showAlert({
          type: 'error',
          message: this.emptyError,
        });
        return;
      }
      if (newValue === this.value) return;
      this.$emit('input', newValue);
    },
    onKeyDown(e) {
      if (e.keyCode === ESCAPE_KEY) {
        this.$refs.input.value = this.value;
        this.$refs.input.blur();
      } else if (e.keyCode === ENTER_KEY) {
        this.$refs.input.blur();
      }
    },
    async toggleEdit() {
      if (!this.editable) {
        this.myEditing = false;
        return;
      }
      this.myEditing = !this.myEditing;
      if (this.myEditing) {
        await this.$nextTick();
        this.$refs.input.focus();
        if (this.editing) {
          this.$refs.input.select();
        }
      }
    },
    stopEditing() {
      this.$emit('edit-ended', this.value);
      this.myEditing = false;
      this.isEditing = false;
    },
  },
});
